export default "__VITE_ASSET__2luXW6uQ__"